import Img from "components/atoms/Img";
import Banner from "components/organisms/Banner";
import ContactUs from "components/organisms/ContactUs";

const FATCA = ({ dataJson }) => {
  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-569"
        breadcrumbs={dataJson.breadcrumbs}
        title={"FATCA Policy"}
        titleProps={{
          className: "banner-default-title mb-6 lg:mb-10 capitalize",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src={`/assets/images/common/${dataJson.banner_image}`}
            wrapper={{
              className: "bbc-banner-image-country xl:top-24",
            }}
            className="w-full "
            width={469}
            height={438}
            priority={true}
            alt="banner-img"
          />
        }
        bgColor={"bg-bbc-terms-policy"}
      ></Banner>

      <section>
        <div className="container mt-10 lg:mt-20">
          <p className="mb-6">
            The <b>Foreign Account Tax Compliance Act</b> (“FATCA”) is U.S.
            legislation which was signed into U.S. Law on 18 March 2010, as part
            of the U.S. Hiring Incentives to Restore Employment (HIRE) Act. The
            fundamental objective of FATCA is to identify those U.S. persons who
            may be evading tax through the use of offshore investment vehicles
            and to ensure that the Internal Revenue Service (“IRS”) can identify
            and collect the appropriate amount of tax from all U.S. persons.
          </p>

          <p className="mb-6">
            Although the primary purpose is the prevention and detection of tax
            evasion by a U.S. person, FATCA will have a significant impact
            across financial markets and will affect non-U.S. companies and
            individuals. FATCA requires all foreign financial institutions
            (“FFIs”) to register with the IRS, perform due diligence to identify
            U.S. accounts and report client data to the IRS directly or to their
            local government through an Intergovernmental Agreement (“IGA”).
            FFIs that do not comply will suffer a 30% withholding tax on all
            U.S. sourced income or payments remitted to them by the U.S. paying
            agents or other FFIs.
          </p>

          <p>
            If you have any questions about <b>FATCA Policy</b>, please contact
            us by email or regular mail at the following address:
          </p>
        </div>
      </section>
      <section>
        <ContactUs />
      </section>
    </>
  );
};

export default FATCA;
